import offsetParent from './offset-parent';

var isBodyOffset = function (element) { return (offsetParent(element) === element.ownerDocument.body); };

export default isBodyOffset;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-popup-common/dist/es/is-body-offset.js
// module id = 378
// module chunks = 0